import React, { useEffect, useContext, useRef } from 'react';
import './OpensInXTime.css';
import { AsgDictionaryContext } from '../../../../contexts';
import { LiveCasinoService } from '../../../../../../shared/src/services/live-casino.service';
import { useFitTextToRows } from '../../../../../../shared/src/hooks/use-fit-text-to-rows.hook';

export const OpensInXTime = ({
    startTime = null,
    showGradient,
}) => {
    const Dictionary = useContext(AsgDictionaryContext);
    const opensInText = useRef();

    useEffect(() => {
        showGradient(Boolean(startTime));
    }, [startTime]);

    useFitTextToRows(
        opensInText,
        1,
        [startTime],
    );

    if (!startTime) {
        return null;
    }

    const timeLeft = LiveCasinoService.getOpensInTime(startTime);

    return (
        <div className="live-casino__message">
            <span ref={opensInText}>
                {`${Dictionary.translate('opensIn')} `}
                <span className="live-casino__message-icon" />
                {` ${timeLeft.h}h ${timeLeft.m}min`}
            </span>
        </div>
    );
};
